// extracted by mini-css-extract-plugin
export default {"container":"ContractsFilterContainer_container__NOrIH","amount":"ContractsFilterContainer_amount__UjED-"};